// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card___2tTXK","default":"styles__default___3jWAb","no-background":"styles__no-background___1Pdo6","active":"styles__active___OugPb"};